import { PublicLinkAccess } from './public-link-tab-access';

/**
 * Paths under `space/:apartmentId` a public link visitor may open (a path is allowed together with everything
 * below it). Everything else (providers, stages, documents, the other settings tabs, the interior designer
 * editor) is closed by construction. `''` is the redirect to the 3D walk. The fallback must stay allowed or the
 * redirect would loop. Dashboard tabs are narrowed further by `isDashboardTabAllowed`.
 */
const VISITOR_PATHS: readonly string[] = ['', 'apartment', 'dashboard', 'property-settings/general-informations'];

/** Dashboard tabs closed to every visitor, whatever the link allows (Resources are Maximo work orders). */
const VISITOR_HIDDEN_DASHBOARD_TABS: readonly string[] = ['dashboard/resources'];

/** Where a visitor lands when a path is not open to them. */
export const PUBLIC_LINK_SPACE_FALLBACK = 'apartment';

function isSame(path: string, allowed: string): boolean {
  return path === allowed || path.startsWith(`${allowed}/`);
}

/**
 * Whether a path relative to `space/:apartmentId` (for example `dashboard/devices` or
 * `property-settings/general-informations`) is open to the visitor. A parent of an allowed path
 * (`property-settings`) is open too, so the router can activate the chain down to the allowed leaf.
 */
export function isSpaceSectionAllowed(path: string, access: PublicLinkAccess): boolean {
  if (!access.active) return true;
  if (VISITOR_HIDDEN_DASHBOARD_TABS.some((hidden) => isSame(path, hidden))) return false;
  if (isSame(path, 'calendar')) return access.capabilities.canViewEvents;
  return VISITOR_PATHS.some((allowed) => isSame(path, allowed) || isSame(allowed, path));
}
